import React from 'react'
import Navbar from "../../Components/Navbar/Navbar";
import './Legal.scss'

function Success() {
    return (
        <div id='legal'>
            <Navbar homeNav="navbar navbar-expand-md bgLegal" />
            <div className='legalSpace text-center'>
                <h1 className='legalHeader successHeader'>Welcome to Frugal Season</h1>
                <p>Ready to get started? Click <a href="">here</a>.</p>
            </div>
        </div>
    )
}

export default Success